<template>
  <div class="system-config">
    <el-tabs type="border-card">
      <el-tab-pane label="小程序配置">
        <el-form :model="miniapp" :rules="miniRules" size="medium" label-width="120px" class="setting-form">
          <el-form-item label="appId" prop="appid">
            <el-input v-model="miniapp.appid" placeholder="请输入 appId" clearable />
          </el-form-item>
          <el-form-item label="appSecret" prop="secret">
            <el-input v-model="miniapp.secret" placeholder="请输入 appSecret" clearable />
          </el-form-item>
          <el-form-item label="小程序名称" prop="name">
            <el-input v-model="miniapp.name" placeholder="请输入小程序名称" clearable />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="跳转到新小程序">
        <el-form :model="upgrade" :rules="upgradeRules" size="medium" label-width="120px" class="setting-form">
          <el-form-item label="appId" prop="appId">
            <el-input v-model="upgrade.appId" placeholder="请输入 appId" clearable />
          </el-form-item>
          <el-form-item label="要打开的版本" prop="envVersion">
            <el-select v-model="upgrade.envVersion" placeholder="请选择要打开的小程序版本" clearable>
              <el-option label="开发版" value="develop" />
              <el-option label="体验版" value="trial" />
              <el-option label="正式版" value="release" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-form size="medium" label-width="135px" class="button-form">
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交保存</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    wechat: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      miniapp: {
        appid: '',
        secret: ''
      },
      miniRules: {
        appid: [{ required: true, message: '请输入 appId', trigger: 'blur' }],
        secret: [{ required: true, message: '请输入 appSecret', trigger: 'blur' }],
        name: [{ required: true, message: '请输入小程序名称', trigger: 'blur' }]
      },
      upgrade: {
        appId: '',
        content: '升级到新的小程序',
        envVersion: ''
      },
      upgradeRules: {
        appId: [{ required: true, message: '请输入 appId', trigger: 'blur' }],
        envVersion: [{ required: true, message: '请选择要打开的小程序版本', trigger: 'blur' }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('./config.scss');
</style>
